export default __webpack_public_path__ + "static/media/steps-none.dc57500f.png";